import React, { Component } from 'react'
import './App.css'
import ReactGA from 'react-ga'
import jwt_decode from 'jwt-decode'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { setJwtToken } from '../redux/auth/authActions'
import { publicLinkActivation } from '../redux/startupApprovedFlowControl/StratupApprovedFlowControlActions'
import { getTokenInLocaleStorage, setTokenInLocalStorage } from '../utils/general'
import { emitPageEvent } from '../metrics/metricsEmitter'

import AngelOnboardingFormsitePage from '../pages/AngelCommunityPage/AngelOnboardingFormsitePage'
import AngelOnboardingTypeformPage from '../pages/AngelCommunityPage/AngelOnboardingTypeformPage'
import SignUpStartup from '../pages/Startup/SignUpStartup/SignUpStartup'
import LoginStartup from '../components/LoginForm/LoginStartup'

import LoginForm1 from '../components/LoginForm/LoginForm1'
import Suspend from './Suspend/suspend'

//education get accredited routes
import { getInvestorProfile } from '../redux/investorFlowControl/investorFlowControlActions'
import {
  ScoutSignup,
  LoginScouts,
  ScoutProfile,
  ScoutSettings,
  ScoutInvite,
  ScoutReferrals,
  ScoutContracts,
  ScoutNotifications,
  ScoutOnboarding,
  Step06Congratulations,
  ScoutEmailConfirmPage,
  ScoutInviteHistory,
  ScoutDeals,
  ScoutContractsAddEntity,
  ScoutSettingsAddRecipient,
} from '../containers/ScoutLazyLoading'
import {
  Faqs,
  NewHomePage,
  BlogListPage,
  PodcastList,
  PodcastViewDetails,
  BlogViewDetails,
  TermsPage,
  PolicyPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  Portfolio,
  AccreditionVerification,
  InvestorPublicLinkProfileComplete,
  AcceleratorHomepage,
} from './OtherLazyLoading'

import {
  StartupApprovedProfileMain,
  MonthlyUpdateAnalytic,
  MonthlyUpdateHistory,
  StatusMain,
  QAFormMain,
  InvestorHistoryMain,
  InvestorFeedbackMain,
  MonthlyUpdateform,
  StartupNotification,
  StartupApprovedSetting,
  EditMonthlyUpdateform,
  InvestorDetail,
  StartupDetail,
  StartupMonthlyUpdates,
  Fundraise,
  PostDetails,
  HistoryViewPost,
  StartupDetailByLinkType,
  PreviewInvestorViewNew,
  PostWritingGuide,
} from './ApprovedStartupLazyLoading'

import {
  InvestorPassedHistory,
  SignUpInvestor,
  InvestorProfile,
  InvestorDealDetail,
  MonthlyUpdates,
  PassDeal,
  PublicQAForum,
  ReviewMemo,
  InvestorInvestingSteps,
  InvestorHistory,
  InvestorNotifications,
  InvestorDeals,
  InvestorStepPage,
  Step12AccreditionStatus,
  LoginInvestor,
  InvestorDealVerification,
  InvestorAnotherInvestment,
  MonthlyUpdatesAnalytics,
  InvestorSettings,
  InvestorPremiumPlans,
  InvestorRationale,
  InvestorInvestedDealDetail,
  PreCommitment,
} from '../containers/InvestorLazyLoading'

import {
  Hiring,
  LoginHiring,
  RegisterHiring,
  HiringStepPage,
  Congratulations,
  AboutYourStartup,
} from '../containers/RecruitLazyLoading'

import StartupInformation from '../pages/Startup/StartupInfoPage/StartupInformation'

import {
  LearnInvestProtectedRoute,
  Series65ProtectedRoute,
  StartupProtectedRoute,
  InvestorProtectedRoute,
  ScoutProtectedRoute,
  RecruitProtectedRoute,
} from './RouteLazyLoading'

import {
  ProfileMain,
  ProfileSettingMain,
  TrackingPreviewInvestorView,
  TrackingMonthlyUpdates,
  EditTrackingMonthlyUpdates,
  TrackingHistoryUpdates,
  TrackingNotification,
  TrackingMonthlyUpdatesForm,
} from '../containers/TrackingLazyLoading'

import {
  GetAccreditedSignup,
  GetAccreditedLogin,
  GetAccreditedSyllabus,
  EducationEmailConfirmPage,
  GetAccreditedSyllabusSelect,
  GetAccreditedReadingMaterialDetails,
  GetAccreditedVideoLectureDetails,
  GetAccreditedQuizzes,
  GetAccreditedQuizDetalis,
  GetAccreditedQuizResult,
  GetAccreditedEducationProfile,
  GetAccreditedEducationSetting,
  GetAccreditedEducationNotification,
  GetAccreditedEducationExams,
  GetAccreditedEducationExamQuiz,
  EducationForgotPasswordPage,
  ErrorRoute404,
  LearnInvestSignup,
  LearnInvestLogin,
  InvestSyllabus,
  SyllabusSelect,
  ReadingMaterialDetails,
  VideoLectureDetails,
  Quizzes,
  QuizDetalis,
  QuizResult,
  EducationInvestProfile,
  EducationInvestSetting,
  EducationInvestNotification,
  EducationInvestExams,
  EducationInvestExamDetails,
  Education,
  EducationInvestCourseDetails,
  GetAccreditedCourseDetails,
  EducationTermService,
} from '../containers/EducationLazyLoading'
import Loader from '../components/Loader/Loader'
import withLayout from '../layouts/withLayout'
import ScoutLayout from '../layouts/ScoutLayout'
import EducationInvestLayout from '../layouts/EducationInvestLayout'
import EducationAccreditedLayout from '../layouts/EducationAccreditedLayout'
import TrackingLayout from '../layouts/TrackingLayout'
import StartupApprovedLayout from '../layouts/StartupApprovedLayout'
import InvestorLayout from '../layouts/InvestorLayout'
import LoginAccelerator from '../components/LoginForm/LoginAccelerator'
import OnboardingFlow from '../pages/Accelerator/OnboardingFlow/OnboardingFlow'
// import TestingPage from '../pages/TestingPage'
import RegisterAccelerator from '../components/RegisterForm/RegisterAccelerator'

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      previousToken: props.token,
    }
  }

  componentDidMount() {
    if (window.location.href?.includes('https://www.')) {
      window.location.href = window.location.href.replace('https://www.', 'https://')
    }
    // Add event listener on the storage token to update the redux react state
    // token when the storage token is modified.

    if (localStorage.getItem('userId') && document.location.pathname.includes('/investor')) {
      this.props.getInvestorProfile(localStorage.getItem('userId'))
    }
    window.addEventListener('storage', event => {
      if (event.key === 'token') {
        const currentStorageToken = getTokenInLocaleStorage()
        if (currentStorageToken !== this.props.token) {
          this.props.setJwtToken(currentStorageToken)
        }
      }
    })

    // Emit page event on initial page load
    emitPageEvent()
  }

  componentDidUpdate(previousProps) {
    if (this.props.location.pathname !== previousProps.location.pathname) {
      // Emit page event for any change in the path.
      emitPageEvent()
    }
  }

  render() {
    const { token, investorStatus, investorUser, startupUser, scoutUser, set_invite_code } = this.props
    let userId = null
    if (token) {
      if (investorStatus) {
        if (investorUser.id) {
          userId = investorUser.id
        }
      } else {
        if (startupUser.id) {
          userId = startupUser.id
        }
        if (scoutUser?.id) {
          userId = scoutUser.id
        }
      }
    }

    ReactGA.initialize('UA-153176601-1', {
      debug: true,
      titleCase: false,
      gaOptions: {
        userId,
      },
    })

    // // Update the previous token and local storage token if the token is changed
    // if (token !== this.state.previousToken) {
    //   const { investor, startup, scout, learnInvest, series65, recruit } = this.props
    //   const portalStates = { investor, startup, scout, learnInvest, series65, recruit }

    //   const activePortal = Object.keys(portalStates).find(key => portalStates[key])
    //   if (activePortal) {
    //     setTokenInLocalStorage(activePortal, token)
    //   }
    //   this.setState({
    //     previousToken: token,
    //   })
    // }
    // const currentToken = getTokenInLocaleStorage()
    // if (currentToken) {
    //   let decodeTokenData = jwt_decode(currentToken)
    //   if (new Date().getTime() >= decodeTokenData.exp * 1000) {
    //     localStorage.clear()
    //     this.props.history.push('/startup')
    //   }
    // }

    function RedirectToLoginScout() {
      return <Redirect to={'/scout/login'} />
    }

    const ThankYouPage = React.lazy(() => import('../pages/Startup/SignUpStartup/ThankYouPage/ThankYouPage'))

    return (
      <div className="App">
        <Helmet>
          <title>Exitfund</title>
          <meta
            name="description"
            content="Connecting the most relevant founders and investors through data-driven intros at the pre-seed and seed stages."
          />
          <meta
            name="keywords"
            content="angel investors for startups, find angel investors, find angel investors online, angel investors search, angel investors website,
          angel investors online, how to find angel investors, technology angel investors, corporate angel investors, angel investors"
          />
        </Helmet>

        <React.Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/" component={NewHomePage} />
            {/* <Route exact path="/test" component={TestingPage} /> */}
            <Route exact path="/startup" component={NewHomePage} />
            <Route exact path="/investor" component={NewHomePage} />
            <Route exact path="/scout" component={NewHomePage} />
            {/* <Route exact path="/accelerator" component={AcceleratorHomepage} /> */}
            <Route exact path="/portfolio" component={Portfolio} />
            <Route exact path="/faqs" component={Faqs} />
            <Route exact path="/blogs" component={BlogListPage} />
            <Route exact path="/blog-view/:id" component={BlogViewDetails} />
            <Route exact path="/podcasts" component={PodcastList} />
            <Route exact path="/suspend" component={Suspend} />
            <Route exact path="/podcast-view/:id" component={PodcastViewDetails} />
            <Route exact path="/education/learn-invest/" component={Education} />
            <Route exact path="/education/get-accredited/" component={Education} />
            <Route exact path="/recruit" component={Hiring} />
            <Route exact path="/recruit/login" component={LoginHiring} />
            <Route exact path="/recruit/signup" component={RegisterHiring} />
            <RecruitProtectedRoute exact path="/recruit/startup-info" component={AboutYourStartup} />
            <RecruitProtectedRoute exact path="/recruit/onboarding/:step" component={HiringStepPage} />
            <RecruitProtectedRoute exact path="/recruit/congratulations" component={Congratulations} />
            <Route exact path="/ScoutOnboarding" component={ScoutOnboarding} />

            <Route exact path="/angel/formsite" component={AngelOnboardingFormsitePage} />
            <Route exact path="/angel/typeform" component={AngelOnboardingTypeformPage} />

            <Route exact path="/login" component={LoginForm1} />
            <Route exact path="/investor/login" component={LoginInvestor} />
            <Route exact path="/startup/login" component={LoginStartup} />
            {/* <Route exact path="/accelerator/signup" component={RegisterAccelerator} />
            <Route exact path="/accelerator/login" component={LoginAccelerator} />
            <Route exact path="/accelerator/onboarding/:step" component={OnboardingFlow} /> */}

            <StartupProtectedRoute exact path="/startup/onboarding/:step" component={StartupInformation} />
            <InvestorProtectedRoute
              exact
              path="/investor/accreditation-verify"
              component={AccreditionVerification}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/profile-complete"
              component={InvestorPublicLinkProfileComplete}
            />
            <InvestorProtectedRoute exact path="/investor/onboarding/:step" component={InvestorStepPage} />
            <Route exact path="/scout/onboarding/:step" component={RedirectToLoginScout} />
            <Route exact path="/scout/congratulations" component={Step06Congratulations} />
            <Route exact path="/investor/signup" component={SignUpInvestor} />
            <Route exact path="/startup/signup" component={SignUpStartup} />
            <StartupProtectedRoute
              exact
              path="/tracking/monthly-update"
              component={withLayout(TrackingMonthlyUpdates, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/submit-monthly-update"
              component={withLayout(TrackingMonthlyUpdatesForm, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/edit-monthly-update/:id"
              component={withLayout(EditTrackingMonthlyUpdates, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/history"
              component={withLayout(TrackingHistoryUpdates, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/profile/:currentTab"
              component={withLayout(ProfileMain, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/setting/:currentTab"
              component={withLayout(ProfileSettingMain, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/preview"
              component={withLayout(TrackingPreviewInvestorView, TrackingLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/tracking/notifications"
              component={withLayout(TrackingNotification, TrackingLayout)}
            />
            <Route exact path="/scout/email-confirm" component={ScoutEmailConfirmPage} />
            <Route exact path="/scout/login" component={LoginScouts} />
            <Route exact path="/scout/signup" component={ScoutSignup} />

            <Route exact path="/scout/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/startup/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/investor/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/recruit/forgot-password" component={ForgotPasswordPage} />

            <Route exact path="/reset/password" component={ResetPasswordPage} />
            <Route exact path="/termsofservice" component={TermsPage} />
            <Route exact path="/policy" component={PolicyPage} />
            <StartupProtectedRoute
              exact
              path="/startup/approve/fundraise/posts/guide"
              component={withLayout(PostWritingGuide, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/profile/:currentTab"
              component={withLayout(StartupApprovedProfileMain, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/settings/:currentTab"
              component={withLayout(StartupApprovedSetting, StartupApprovedLayout)}
            />

            <StartupProtectedRoute
              exact
              path="/startup/approve/dashboard/status"
              component={withLayout(StatusMain, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/dashboard/q&a-forum"
              component={withLayout(QAFormMain, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/investors/investors-history"
              component={withLayout(InvestorHistoryMain, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/investors/investors-feedback"
              component={withLayout(InvestorFeedbackMain, StartupApprovedLayout)}
            />

            <StartupProtectedRoute
              exact
              path="/startup/approve/monthly-updates"
              component={withLayout(MonthlyUpdateHistory, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/monthly-updates/submit-update"
              component={withLayout(MonthlyUpdateform, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/edit-monthly-update/:id"
              component={withLayout(EditMonthlyUpdateform, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/monthly-updates/analytics"
              component={withLayout(MonthlyUpdateAnalytic, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/notifications"
              component={withLayout(StartupNotification, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/preview"
              component={withLayout(PreviewInvestorViewNew, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/investor-detail/:id"
              component={withLayout(InvestorDetail, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/fundraise/post-all"
              component={withLayout(PostDetails, StartupApprovedLayout)}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approve/fundraise/:tabKey" // invite-investors, invite-history, posts
              component={Fundraise}
            />
            <StartupProtectedRoute
              exact
              path="/startup/approved/fundraise/view-history/:id"
              component={withLayout(HistoryViewPost, StartupApprovedLayout)}
            />
            <StartupProtectedRoute exact path="/startup/thankyou" component={ThankYouPage} />
            {/* Scout portal Routes */}
            <ScoutProtectedRoute
              path={[
                '/scout/profile',
                '/scout/settings/:Tab',
                '/scout/settings/carry-recipient/add-recipient',
                '/scout/invite',
                '/scout/deals',
                '/scout/referrals',
                '/scout/contracts',
                '/scout/contracts/add-entity',
                '/scout/notifications',
                '/scout/invite/history',
              ]}
              render={({ match: { path } }) => (
                <ScoutLayout>
                  <Switch>
                    <Route exact path={`/scout/profile`} component={ScoutProfile} />
                    <Route exact path={`/scout/settings/:Tab`} component={ScoutSettings} />
                    <Route
                      exact
                      path={`/scout/settings/carry-recipient/add-recipient`}
                      component={ScoutSettingsAddRecipient}
                    />
                    <Route exact path={`/scout/invite`} component={ScoutInvite} />
                    <Route exact path={`/scout/deals`} component={ScoutDeals} />

                    <Route exact path={`/scout/referrals`} component={ScoutReferrals} />
                    <Route exact path={`/scout/contracts`} component={ScoutContracts} />
                    <Route exact path={`/scout/contracts/add-entity`} component={ScoutContractsAddEntity} />
                    <Route exact path={`/scout/notifications`} component={ScoutNotifications} />
                    <Route exact path={`/scout/invite/history`} component={ScoutInviteHistory} />
                  </Switch>
                </ScoutLayout>
              )}
            />
            {/* <ScoutProtectedRoute
              exact
              path="/scout/profile"
              component={withLayout(ScoutProfile, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/settings/:Tab"
              component={withLayout(ScoutSettings, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/settings/carry-recipient/add-recipient"
              component={withLayout(ScoutSettingsAddRecipient, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/invite"
              component={withLayout(ScoutInvite, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute exact path="/scout/deals" component={withLayout(ScoutDeals, ScoutLayout)} /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/referrals"
              component={withLayout(ScoutReferrals, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/contracts"
              component={withLayout(ScoutContracts, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/contracts/add-entity"
              component={withLayout(ScoutContractsAddEntity, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/notifications"
              component={withLayout(ScoutNotifications, ScoutLayout)}
            /> */}
            {/* <ScoutProtectedRoute
              exact
              path="/scout/invite/history"
              component={withLayout(ScoutInviteHistory, ScoutLayout)}
            /> */}

            {/* Investor Routes */}

            <InvestorProtectedRoute
              exact
              path="/investor/invested-deal-info/:id"
              component={withLayout(InvestorInvestedDealDetail, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/deals/:id"
              component={withLayout(InvestorDealDetail, InvestorLayout)}
            />
            <InvestorProtectedRoute exact path="/investor/profile" component={InvestorProfile} />
            <InvestorProtectedRoute exact path="/investor/premium-plans" component={InvestorPremiumPlans} />
            <InvestorProtectedRoute
              exact
              path="/investor/deals"
              // component={withLayout(InvestorDeals, InvestorLayout)}
              component={InvestorDeals}
              statusCheck="approved"
            />
            <InvestorProtectedRoute
              exact
              path="/investor/monthly-updates/:id"
              component={withLayout(MonthlyUpdates, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/monthly-updates/analytics/:id"
              component={withLayout(MonthlyUpdatesAnalytics, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/pass-deal"
              component={withLayout(PassDeal, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/public-qaforum"
              component={withLayout(PublicQAForum, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/review-memo"
              component={withLayout(ReviewMemo, InvestorLayout)}
            />
            <InvestorProtectedRoute exact path="/investor/invest" component={InvestorInvestingSteps} />
            <InvestorProtectedRoute exact path="/investor/history-invested" component={InvestorHistory} />
            <InvestorProtectedRoute exact path="/investor/history-passed" component={InvestorPassedHistory} />
            <InvestorProtectedRoute
              exact
              path="/investor/another-investment"
              // component={withLayout(InvestorAnotherInvestment, InvestorLayout)}
              component={InvestorAnotherInvestment}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/deal-verification/:id"
              component={withLayout(InvestorDealVerification, InvestorLayout)}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/settings/:currentTab"
              component={InvestorSettings}
            />
            <InvestorProtectedRoute
              exact
              path="/investor/notifications"
              component={withLayout(InvestorNotifications, InvestorLayout)}
            />
            <InvestorProtectedRoute exact path="/investor/rationale" component={InvestorRationale} />
            <InvestorProtectedRoute exact path="/investor/thankyou">
              <ThankYouPage />
            </InvestorProtectedRoute>
            <InvestorProtectedRoute path="/investor/accreditation">
              <Step12AccreditionStatus />
            </InvestorProtectedRoute>
            {/* <InvestorProtectedRoute
              exact
              path="/investor/pre-commitment"
              component={withLayout(PreCommitment, InvestorLayout)}
            /> */}

            {/* Education portal learn invest routes */}
            <Route exact path="/education/learn-invest/signup" component={LearnInvestSignup} />
            <Route exact path="/education/learn-invest/login" component={LearnInvestLogin} />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/termsofservice"
              component={withLayout(EducationTermService, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/syllabus"
              component={withLayout(InvestSyllabus, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/select-syllabus"
              component={withLayout(SyllabusSelect, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/reading-material/:syllabusId"
              component={withLayout(ReadingMaterialDetails, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/video-lecture/:syllabusId"
              component={withLayout(VideoLectureDetails, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/quizzes/:syllabusId"
              component={withLayout(Quizzes, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/quiz-detail/:quizId"
              component={withLayout(QuizDetalis, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/quiz-result/:quizId"
              component={withLayout(QuizResult, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/profile"
              component={withLayout(EducationInvestProfile, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/setting"
              component={withLayout(EducationInvestSetting, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/notifications"
              component={withLayout(EducationInvestNotification, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/exams"
              component={withLayout(EducationInvestExams, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/exams/:examId"
              component={withLayout(EducationInvestExamDetails, EducationInvestLayout)}
            />
            <LearnInvestProtectedRoute
              exact
              path="/education/learn-invest/course-details"
              component={withLayout(EducationInvestCourseDetails, EducationInvestLayout)}
            />

            {/* Education portal get-accredited routes */}
            <Route exact path="/education/get-accredited/signup" component={GetAccreditedSignup} />
            <Route exact path="/education/get-accredited/login" component={GetAccreditedLogin} />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/termsofservice"
              component={withLayout(EducationTermService, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/syllabus"
              component={withLayout(GetAccreditedSyllabus, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/select-syllabus"
              component={withLayout(GetAccreditedSyllabusSelect, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/reading-material/:syllabusId"
              component={withLayout(GetAccreditedReadingMaterialDetails, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/video-lecture/:syllabusId"
              component={withLayout(GetAccreditedVideoLectureDetails, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/quizzes/:syllabusId"
              component={withLayout(GetAccreditedQuizzes, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/quiz-detail/:quizId"
              component={withLayout(GetAccreditedQuizDetalis, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/quiz-result/:quizId"
              component={withLayout(GetAccreditedQuizResult, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/profile"
              component={withLayout(GetAccreditedEducationProfile, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/setting"
              component={withLayout(GetAccreditedEducationSetting, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/notifications"
              component={withLayout(GetAccreditedEducationNotification, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/exams"
              component={withLayout(GetAccreditedEducationExams, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/exams/:examId"
              component={withLayout(GetAccreditedEducationExamQuiz, EducationAccreditedLayout)}
            />
            <Series65ProtectedRoute
              exact
              path="/education/get-accredited/course-details"
              component={withLayout(GetAccreditedCourseDetails, EducationAccreditedLayout)}
            />
            <Route
              exact
              path={'/education/learn-invest/forgot-password'}
              component={EducationForgotPasswordPage}
            />
            <Route
              exact
              path={'/education/get-accredited/forgot-password'}
              component={EducationForgotPasswordPage}
            />
            <Route exact path={'/education/email-confirm'} component={EducationEmailConfirmPage} />
            <Route
              exact
              path="/startup/:personalInviteCode/:startupName/monthly-updates"
              component={StartupMonthlyUpdates}
            />
            <Route
              exact
              path="/:linkType/:startupName/:inviteCode/:inviterInviteCode"
              inviteCode={set_invite_code}
              component={StartupDetailByLinkType}
            />
            <Route
              exact
              path="/startup/:startupName/:inviteCode"
              inviteCode={set_invite_code}
              component={StartupDetail}
            />
            {/* Error */}
            <Route component={ErrorRoute404} />
          </Switch>
        </React.Suspense>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  startupPage: state.home.startupPage,
  investorPage: state.home.investorPage,
  scoutPage: state.home.scoutPage,
  trackingPage: state.home.trackingPage,
  token: state.auth.token,
  investorStatus: state.auth.investor,
  startupUser: state.auth.startupUser,
  investorUser: state.auth.user,
  scoutUser: state?.auth?.scoutUser,
  set_invite_code: state.StratupApprovedFlowControlReducers.set_invite_code,
  investorLoading: state?.investorflowControl.loading,
  investor: state.auth.investor,
  startup: state.auth.startup,
  scout: state.auth.scout,
  learnInvest: state.auth.learnInvest,
  series65: state.auth.series65,
  recruit: state.auth.recruit,
})

const mapDispatchToProps = dispatch => ({
  setJwtToken: token => {
    dispatch(setJwtToken(token))
  },
  publicLinkActivation: data => {
    dispatch(publicLinkActivation(data))
  },
  getInvestorProfile: data => {
    dispatch(getInvestorProfile(data))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
